<template>
  <div
    class="menu-category-icon"
    :style="iconBallStyle"
  >
    <SvgIcon :data="moduleCategory.icon" />
  </div>
</template>

<script>
export default {
  name: 'MenuCategoryIcon',
  props: {
    moduleCategory: {
      type: Object,
      required: true,
    },
  },
  computed: {
    iconBallStyle() {
      return {
        background: this.moduleCategory.color,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .menu-category-icon {
    color: var(--menu-module-category-text-hex);
    width: 35px;
    height: 35px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;

    svg {
      transform: none;
      font-size: 22px;
      color: var(--accent-text-alt-color-hex);
    }
  }
</style>
